import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHorizontalAlignmentTop"><Path d="M3 3V4.5H21V3H3Z" fill="currentColor"/><Path d="M6 6V21H11V6H6Z" fill="currentColor"/><Path d="M13 6V17H18V6H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHorizontalAlignmentTop;
